<template>
  <div class="app-container overview-container">
    <iframe height="100%" width="100%" :src="vrSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vrSrc: ''
    }
  },

  mounted() {
    this.vrSrc = process.env.NODE_ENV === 'development'
      ? 'http://10.0.10.28:56443/'
      : '../pano/tour.html?startscene=3'

    window.addEventListener('message', (event) => {
      if (event.data) {
        if (event.data === 'back') {
          this.$emit('change-com', 'index')
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: rgba(244, 223, 156, 0.2);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #f4df9c;
}
</style>

<style lang="scss" scoped>
.overview-container {
  background-repeat: no-repeat;
  background-size: 100% 100%;

  iframe {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
